var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"c-question-btn"},[_c('input',{staticClass:"check",attrs:{"type":"radio","name":_vm.id},domProps:{"checked":_vm.isActive},on:{"click":function($event){return _vm.onclick(_vm.id, _vm.text)}}}),_c('div',{class:`button ${_vm.color}`},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }